export default __webpack_public_path__ + "static/media/CZ.108380b6.svg";